export const FETCH_TASK_LIST_REQUEST = "FETCH_TASK_LIST_REQUEST";
export const FETCH_TASK_LIST_SUCCESS = "FETCH_TASK_LIST_SUCCESS";
export const FETCH_TASK_LIST_FAILURE = "FETCH_TASK_LIST_FAILURE";

export const FETCH_LOADER_LIST_REQUEST = "FETCH_LOADER_LIST_REQUEST";
export const FETCH_LOADER_LIST_SUCCESS = "FETCH_LOADER_LIST_SUCCESS";
export const FETCH_LOADER_LIST_FAILURE = "FETCH_LOADER_LIST_FAILURE";

export const FETCH_EVENT_TASK_LIST_REQUEST = "FETCH_EVENT_TASK_LIST_REQUEST";
export const FETCH_EVENT_TASK_LIST_SUCCESS = "FETCH_EVENT_TASK_LIST_SUCCESS";
export const FETCH_EVENT_TASK_LIST_FAILURE = "FETCH_EVENT_TASK_LIST_FAILURE";

export const FETCH_EVENT_LIST_REQUEST = "FETCH_EVENT_LIST_REQUEST";
export const FETCH_EVENT_LIST_SUCCESS = "FETCH_EVENT_LIST_SUCCESS";
export const FETCH_EVENT_LIST_FAILURE = "FETCH_EVENT_LIST_FAILURE";

export const FETCH_OUTBOUND_LIST_REQUEST = "FETCH_OUTBOUND_LIST_REQUEST";
export const FETCH_OUTBOUND_LIST_SUCCESS = "FETCH_OUTBOUND_LIST_SUCCESS";
export const FETCH_OUTBOUND_LIST_FAILURE = "FETCH_OUTBOUND_LIST_FAILURE";

export const FETCH_INBOUND_LIST_REQUEST = "FETCH_INBOUND_LIST_REQUEST";
export const FETCH_INBOUND_LIST_SUCCESS = "FETCH_INBOUND_LIST_SUCCESS";
export const FETCH_INBOUND_LIST_FAILURE = "FETCH_INBOUND_LIST_FAILURE";

export const POST_TASK_REQUEST = "POST_TASK_REQUEST";
export const POST_TASK_SUCCESS = "POST_TASK_SUCCESS";
export const POST_TASK_FAILURE = "POST_TASK_FAILURE";

export const FETCH_TASK_CONNECTION_REQUEST = "FETCH_TASK_CONNECTION_REQUEST";
export const FETCH_TASK_CONNECTION_SUCCESS = "FETCH_TASK_CONNECTION_SUCCESS";
export const FETCH_TASK_CONNECTION_FAILURE = "FETCH_TASK_CONNECTION_FAILURE";
export const FETCH_TASK_CONNECTION_RESET = "FETCH_TASK_CONNECTION_RESET";


export const POST_TASK_CONNECTION_REQUEST = "POST_TASK_CONNECTION_REQUEST";
export const POST_TASK_CONNECTION_SUCCESS = "POST_TASK_CONNECTION_SUCCESS";
export const POST_TASK_CONNECTION_FAILURE = "POST_TASK_CONNECTION_FAILURE";
export const POST_TASK_CONNECTION_RESET = "POST_TASK_CONNECTION_RESET";

// PUT Task
export const PUT_TASK_REQUEST = "PUT_TASK_REQUEST";
export const PUT_TASK_SUCCESS = "PUT_TASK_SUCCESS";
export const PUT_TASK_FAILURE = "PUT_TASK_FAILURE";
export const PUT_TASK_RESET = "PUT_TASK_RESET";